import { Loaders, Typography, CircularLoader } from "@plum-xoxo/admin-dsm";
import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  color: ${(props) => props.theme.palette.primary.c03};
`;

export default function PageLoader(props) {
  return (
    <StyledDiv
      className="d-flex flex-column align-items-center justify-content-center w-100"
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translateX(-50%)",
      }}
    >
      {props.value ? (
        <>
          <div style={{ width: "25%" }}>
            <Loaders variant="determinate" color="inherit" {...props} />
          </div>
          {/* <div className="mt-8">
            <Typography color="dark" shade="c300">{`${Math.round(
              props.value
            )}%`}</Typography>
          </div> */}
        </>
      ) : (
        <CircularLoader size="lg" />
      )}
    </StyledDiv>
  );
}
